// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"adb622b5","187":"b0b6e59c","237":"71ccd042","346":"ede9f44b","473":"21d3f966","553":"ec6859c6","965":"f220827b","978":"24115890"}[chunkId] + ".chunk.js";
};